import { useMutation, useQuery, useQueryClient, UseQueryOptions } from "react-query";
import { getDSSForm, getDSSFormValues, getDSSPage } from "../services/dss.service";
import { IRequest } from "../interfaces/authentication.interface";
import { IDSSPage } from "../interfaces/dss.interface";

export function useGetDSSForm() {
    return useMutation((p: { locale: string }) => getDSSForm(p.locale))
}

export function useGetDssFormValues() {
    return useMutation(_ => getDSSFormValues())
}

export function useGetDSSPage<T extends any = IRequest<IDSSPage>>(
    lang: string,
    options?: UseQueryOptions<any, unknown, T>
) {

    const cache = useQueryClient().getQueryData(["dssPage"]);

    return useQuery({
        queryKey: ["dssPage"],
        queryFn: () => cache ? cache : getDSSPage(lang),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
